// eslint-disable-next-line no-shadow
enum InputEnum {
  text,
  password,
  select
}

export default InputEnum
